<div id="app-chat" role="tabpanel" class="tab-pane fade show active in">
    <div class="announcement-inner">
        <div class="announcement-inner-header">
            <a href="javascript:void(0);" class="new-alert"><span
                    id="unreadCount">{{AnnouncementDetail['TotalUnreadRecords']}}</span>
                {{bs.getResource('rbkey_UnRdAnnncmnt')}} </a>
            <div class="right-head">
                <a href="javascript:void(0);" style="display:none;"
                    class="mark-read-btn">{{bs.getResource('rbkey_MrkAllAsRd')}}</a>
                <div class="btn-group">
                    <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">
                        {{AnnouncementOrderBy}}
                        <!-- <span class="caret"></span> -->
                    </a>
                    <ul role="menu" class="dropdown-menu animated fadeIn right">
                        <li *ngFor="let sortItem of AnnouncementOrderByList">
                            <a href="javascript:void(0);" (click)="orderBy(sortItem)"style="display: block;">{{sortItem.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="announcement-tab-list">
            <div *ngFor="let item of TodayAnnouncementItems; let i = index" [attr.data-index]="i">
                <div id="announcementDiv{{item['AnnoncementId']}}" [ngClass]="setTodayClassName(i)">
                    <div class="atl-box-top">
                        <div class="atl-left-image">
                            <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_AnncntThmbnlLBL')}}"
                                *ngIf="item['Thumbnail']!=''">
                            <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_AnncntHrnLBL')}}"
                                *ngIf="item['Thumbnail']==''">
                        </div>
                        <div class="atl-right-block">
                            <div class="atlr-top-name">
                                <a href="javascript:void(0);" [innerHTML]="item['Title']"></a>
                            </div>
                            <div class="announcement-description">
                                {{item['Description'] | escape}}
                                <span>
                                    <a href="javascript:void(0);" *ngIf="item['IsMore']"
                                        (click)="OpenAnnouncement(item)"
                                        class="">...{{bs.getResource('rbkey_SeeMrLBL')}}</a>
                                </span>
                            </div>
                            <a href="javascript:void(0);" class="data-image-sec">
                                <a href="{{item['Attachment']}}" target="_blank" *ngIf="item['AttachmentName']!=''">
                                    <span>{{item['AttachmentName']}}</span>
                                </a>
                            </a>
                            <div class="atl-right-position">
                                <div class="atl-right-inner">
                                    <a href="javascript:void(0);" class="book-icon"
                                        (click)="readAnnouncement(item['AnnoncementId'], item['IsRead'], item['IsAcknowledgementRequired'])"></a>
                                    <!-- <a href="javascript:void(0);" (click)="readAnnouncement(item['AnnoncementId'])" class="book-icon" data-toggle="tooltip" data-placement="top" title="" data-original-title="Mark as read"></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="atl-box-bottom">
                        <ul class="atl-bottom-list">
                            <li>
                                <div class="head">{{bs.getResource('rbkey_Crtr_LBL')}}</div>
                                <div class="subhead">{{item['CreatedBy']}}</div>
                            </li>
                            <li>
                                <div class="head">{{bs.getResource('rbkey_AvltyLBL')}}</div>
                                <div class="subhead">{{item['Availabilty']}}</div>
                            </li>
                            <li>
                                <div class="head">{{bs.getResource('rbkey_TimeAndDateLBL')}}</div>
                                <div class="subhead">{{item['CreationDate']}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="day-section" *ngIf="YesterdayAnnouncementItems.length > 0">
                <span class="day">{{bs.getResource('rbkey_YstrdyLBL')}}</span>
                <div class="border-bottom"></div>
            </div>
            <div *ngFor="let item of YesterdayAnnouncementItems; let j = index" [attr.data-index]="j">
                <div id="announcementDiv{{item['AnnoncementId']}}" [ngClass]="setYesterdayClassName(j)">

                    <div class="atl-box-top">
                        <div class="atl-left-image">
                            <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_AnncntThmbnlLBL')}}"
                                *ngIf="item['Thumbnail']!=''">
                            <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_AnncntHrnLBL')}}"
                                *ngIf="item['Thumbnail']==''">
                        </div>
                        <div class="atl-right-block">
                            <div class="atlr-top-name">
                                <a href="javascript:void(0);">{{item['Title'] | escape}}</a>
                            </div>
                            <div class="announcement-description">
                                <span> {{item['Description'] | escape}}
                                    <a href="javascript:void(0);" class="see-more" *ngIf="item['IsMore']"
                                        (click)="OpenAnnouncement(item)">...{{bs.getResource('rbkey_SeeMrLBL')}}</a>
                                </span>
                            </div>
                            <a href="javascript:void(0);" class="data-image-sec">
                                <a href="{{item['Attachment']}}" target="_blank" *ngIf="item['AttachmentName']!=''">
                                    <span>{{item['AttachmentName']}}</span>
                                </a>
                            </a>
                            <div class="atl-right-position">
                                <div class="atl-right-inner">
                                    <!-- <a href="javascript:void(0);" (click)="readAnnouncement(item['AnnoncementId'])" class="book-icon" data-toggle="tooltip" data-placement="top" title="" data-original-title="Mark as read"></a> -->
                                    <a href="javascript:void(0);" class="book-icon"
                                        (click)="readAnnouncement(item['AnnoncementId'], item['IsRead'], item['IsAcknowledgementRequired'])"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="atl-box-bottom">
                        <ul class="atl-bottom-list">
                            <li>
                                <div class="head">{{bs.getResource('rbkey_Crtr_LBL')}}</div>
                                <div class="subhead">{{item['CreatedBy']}}</div>
                            </li>
                            <li>
                                <div class="head">{{bs.getResource('rbkey_AvltyLBL')}}</div>
                                <div class="subhead">{{item['Availabilty']}}</div>
                            </li>
                            <li>
                                <div class="head">{{bs.getResource('rbkey_TimeAndDateLBL')}}</div>
                                <div class="subhead">{{item['CreationDate']}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="day-section" *ngIf="OldAnnouncementItems.length > 0">
                <span class="day">{{bs.getResource('rbkey_OldrLBL')}}</span>
                <div class="border-bottom"></div>
            </div>
            <div>
                <div *ngFor="let item of OldAnnouncementItems; let k = index" [attr.data-index]="k">
                    <div id="announcementDiv{{item['AnnoncementId']}}" [ngClass]="setOldClassName(k)">
                        <div class="atl-box-top">
                            <div class="atl-left-image">
                                <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_AnncntThmbnlLBL')}}"
                                    *ngIf="item['Thumbnail']!=''">
                                <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_AnncntHrnLBL')}}"
                                    *ngIf="item['Thumbnail']==''">
                            </div>
                            <div class="atl-right-block">
                                <div class="atlr-top-name">
                                    <a href="javascript:void(0);">{{item['Title'] | escape}}</a>
                                </div>
                                <div class="announcement-description">
                                    <span> {{item['Description'] | escape}}
                                        <a style="color:#5d9cec !important" href="javascript:void(0);"
                                            *ngIf="item['IsMore']" class="see-more"
                                            (click)="OpenAnnouncement(item)">...{{bs.getResource('rbkey_SeeMrLBL')}}</a>
                                    </span>
                                </div>
                                <a href="javascript:void(0);" class="data-image-sec">
                                    <a href="{{item['Attachment']}}" target="_blank" *ngIf="item['AttachmentName']!=''">
                                        <span>{{item['AttachmentName']}}</span>
                                    </a>
                                </a>
                                <div class="atl-right-position">
                                    <div class="atl-right-inner">
                                        <!-- <a href="javascript:void(0);" class="book-icon" data-toggle="tooltip" data-placement="top" title="" data-original-title="Mark as read"></a> -->
                                        <a href="javascript:void(0);" class="book-icon"
                                            (click)="readAnnouncement(item['AnnoncementId'], item['IsRead'], item['IsAcknowledgementRequired'])"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="atl-box-bottom">
                            <ul class="atl-bottom-list">
                                <li>
                                    <div class="head">{{bs.getResource('rbkey_Crtr_LBL')}}</div>
                                    <div class="subhead">{{item['CreatedBy']}}</div>
                                </li>
                                <li>
                                    <div class="head">{{bs.getResource('rbkey_AvltyLBL')}}</div>
                                    <div class="subhead">{{item['Availabilty']}}</div>
                                </li>
                                <li>
                                    <div class="head">{{bs.getResource('rbkey_TimeAndDateLBL')}}</div>
                                    <div class="subhead">{{item['CreationDate']}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="announcement-tab-list" *ngIf="AnnouncementItems.length==0"><span
                class="noMoreRecord">{{bs.getResource('rbkey_No_Itm_Dsply')}}</span></div>

        <div class="announcement-inner-header" *ngIf="AnnouncementDetail['TotalRecords'] > 10">
            <!-- <div class="announcement-inner-header" > -->
            <div class="left-head">
                <a href="javascript:void(0);" (click)="navigateListPage()"
                    class="mark-read-btn">{{bs.getResource('rbkey_CnvrstnVwMrLBL')}}</a>
            </div>
        </div>
    </div>
    <announcement-detail [AnnouncementSummary]="announcementSummary" *ngIf="EnableDetail"></announcement-detail>

    <app-esign [scope]="'NtfctnAnn'" (acceptClick)="AcknowledgeEsign($event)"></app-esign>
</div>